import { lazy, Suspense } from 'react';
import { Loading } from './components/ui';

const LazyEntityCloudflareWorkerContent = lazy(() =>
  import('./components/EntityCloudflareWorkerContent').then(m => ({
    default: m.EntityCloudflareWorkerContent,
  })),
);

/**
 * Entity page tab content for Cloudflare Worker components.
 *
 * The catalog entity page is still a legacy `EntityLayout`, where native
 * `EntityContentBlueprint` extensions do not render, so this stays a plain
 * component rendered inside `EntityLayout.Route` until the catalog moves to
 * the native frontend system. It is lazy-loaded like the previous routable
 * extension.
 */
export const EntityCloudflareWorkerContent = () => (
  <Suspense fallback={<Loading />}>
    <LazyEntityCloudflareWorkerContent />
  </Suspense>
);
